export default __webpack_public_path__ + "static/media/ic_svc_game_launcher.5c1f7607.png";